import * as React from 'react';
import {FlatList, ListRenderItemInfo} from 'react-native';

import ManuscriptListItem from './ManuscriptListItem';
import NoManuscripts from './NoManuscripts';

import ListItemNormalSeparator from '../../shared/lists/separators/ListItemNormalSeparator';

import ProjectManuscript from '../../../../domain/entities/ProjectManuscript';

interface Props {
  manuscripts: ProjectManuscript[];
  ListHeaderComponent?:
    | React.ComponentType<any>
    | React.ReactElement
    | null
    | undefined;
}

const ManuscriptList: React.FC<Props> = props => {
  const {manuscripts, ListHeaderComponent} = props;
  const renderItem = React.useCallback(
    (info: ListRenderItemInfo<ProjectManuscript>) => (
      <ManuscriptListItem manuscript={info.item} />
    ),
    [],
  );
  return (
    <FlatList
      data={manuscripts}
      renderItem={renderItem}
      ListHeaderComponent={ListHeaderComponent}
      ListFooterComponent={
        manuscripts.length === 0 ? null : ListItemNormalSeparator
      }
      ItemSeparatorComponent={ListItemNormalSeparator}
      ListEmptyComponent={NoManuscripts}
    />
  );
};

export default React.memo(ManuscriptList);
